import { Reducer } from 'redux';
import { AppConstants } from './constants';

export interface IAppState {
  inited: boolean;
  hiddenNotifications?: { [key: string]: string };
}

const initialState: IAppState = {
  inited: false,
  hiddenNotifications: {},
};

const appReducer: Reducer<IAppState> = (state = initialState, { type } = { type: '' }) => {
  switch (type) {
    case AppConstants.APP_INITED: {
      return { ...state, inited: true };
    }
    case AppConstants.APP_HIDE_NOTIFICATION: {
      return { ...state, hiddenNotifications: { ...state.hiddenNotifications } };
    }
    default:
      return state;
  }
};

export default appReducer;
